module.exports = __webpack_public_path__ + "static/img/team.e22bb8d5.svg";